import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Orders from "@/pages/Orders";
import Expenses from "@/pages/Expenses";
import Inventory from "@/pages/Inventory";
import Invoices from "@/pages/Invoices";
import Financial from "@/pages/Financial";
import Settings from "@/pages/Settings";
import { Toaster } from "@/components/ui/sonner";

function Shell({ children }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Shell><Dashboard /></Shell>} />
            <Route path="/clientes" element={<Shell><Clients /></Shell>} />
            <Route path="/ordens" element={<Shell><Orders /></Shell>} />
            <Route path="/gastos" element={<Shell><Expenses /></Shell>} />
            <Route path="/estoque" element={<Shell><Inventory /></Shell>} />
            <Route path="/notas" element={<Shell><Invoices /></Shell>} />
            <Route path="/financeiro" element={<Shell><Financial /></Shell>} />
            <Route path="/configuracoes" element={<Shell><Settings /></Shell>} />
          </Routes>
        </BrowserRouter>
      </SettingsProvider>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "rgba(2,6,23,0.9)",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </AuthProvider>
  );
}

export default App;
